export const PAGE_LAYOUT_TYPE = {
  ONELINE: 'list',
  TWOLINE: 'twoLine',
  CARD: 'card',
  GALLERY: 'gallery',
  MASONRY: 'masonry',
  YEARLY: 'yearly',
  MONTH_GROUP: 'monthGroup',
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
  MINI: 'mini',
  EXTEND: 'extend',
  ROLLPLAY: 'rollplay',
  CAMP: 'camp',
  DEFAULT: 'default',
  DIARY: 'diary',
  WEEKLY: 'weekly',
  TICKET: 'ticket',
  STORY: 'story',
  BLOG: 'blog',
  MONTHLY: 'monthly',
  CHAT: 'chat',
  PORTFOLIO: 'portfolio',
} as const;

export type PAGE_LAYOUT_TYPE_KEY = keyof typeof PAGE_LAYOUT_TYPE;
export type PAGE_LAYOUT_TYPE_VALUE =
  typeof PAGE_LAYOUT_TYPE[PAGE_LAYOUT_TYPE_KEY];

export const PAGE_LAYOUT_MAP = {
  [PAGE_LAYOUT_TYPE.ONELINE]: '한줄형',
  [PAGE_LAYOUT_TYPE.TWOLINE]: '여러줄형',
  [PAGE_LAYOUT_TYPE.CARD]: '카드형',
  [PAGE_LAYOUT_TYPE.GALLERY]: '갤러리형',
  [PAGE_LAYOUT_TYPE.VERTICAL]: '세로형',
  [PAGE_LAYOUT_TYPE.HORIZONTAL]: '가로형',
  [PAGE_LAYOUT_TYPE.MINI]: '미니형',
  [PAGE_LAYOUT_TYPE.EXTEND]: '확장형',
  [PAGE_LAYOUT_TYPE.ROLLPLAY]: '롤플레이형',
  [PAGE_LAYOUT_TYPE.CAMP]: '소속/진영 형',
  [PAGE_LAYOUT_TYPE.DEFAULT]: '기본형',
  [PAGE_LAYOUT_TYPE.DIARY]: '일간형',
  [PAGE_LAYOUT_TYPE.WEEKLY]: '주간형',
  [PAGE_LAYOUT_TYPE.TICKET]: '티켓형',
  [PAGE_LAYOUT_TYPE.STORY]: '스토리형',
  [PAGE_LAYOUT_TYPE.MONTHLY]: '월간형',
  [PAGE_LAYOUT_TYPE.MASONRY]: '지그재그형(메이슨리)',
  [PAGE_LAYOUT_TYPE.YEARLY]: '년도별형',
  [PAGE_LAYOUT_TYPE.MONTH_GROUP]: '월별형',
  [PAGE_LAYOUT_TYPE.CHAT]: '채팅형',
  [PAGE_LAYOUT_TYPE.PORTFOLIO]: '포폴형',
};

export const PAGE_LAYOUT_ICON_MAP = {
  [PAGE_LAYOUT_TYPE.ONELINE]: 'HorizontalBlock14',
  [PAGE_LAYOUT_TYPE.TWOLINE]: 'VerticalBlock14',
  [PAGE_LAYOUT_TYPE.CARD]: 'Gallery14',
  [PAGE_LAYOUT_TYPE.GALLERY]: 'Gallery14',
  [PAGE_LAYOUT_TYPE.VERTICAL]: 'VerticalBlock14',
  [PAGE_LAYOUT_TYPE.HORIZONTAL]: 'HorizontalBlock14',
  [PAGE_LAYOUT_TYPE.MINI]: 'Gallery14',
  [PAGE_LAYOUT_TYPE.EXTEND]: 'Gallery14',
  [PAGE_LAYOUT_TYPE.ROLLPLAY]: 'Gallery14',
  [PAGE_LAYOUT_TYPE.CAMP]: 'VerticalBlock14',
  [PAGE_LAYOUT_TYPE.DEFAULT]: 'Gallery14',
  [PAGE_LAYOUT_TYPE.DIARY]: 'HorizontalBlock14',
  [PAGE_LAYOUT_TYPE.WEEKLY]: 'VerticalBlock14',
  [PAGE_LAYOUT_TYPE.TICKET]: 'HorizontalBlock14',
  [PAGE_LAYOUT_TYPE.STORY]: 'Gallery14',
  [PAGE_LAYOUT_TYPE.MONTHLY]: 'Gallery14',
  [PAGE_LAYOUT_TYPE.MASONRY]: 'Masonry14',
  [PAGE_LAYOUT_TYPE.YEARLY]: 'Yearly14',
  [PAGE_LAYOUT_TYPE.MONTH_GROUP]: 'Monthly14',
  [PAGE_LAYOUT_TYPE.CHAT]: 'Mail20',
  [PAGE_LAYOUT_TYPE.PORTFOLIO]: 'Gallery14',
};

export interface IpageLayoutSetting {
  [PAGE_LAYOUT_TYPE.ONELINE]?: boolean;
  [PAGE_LAYOUT_TYPE.TWOLINE]?: boolean;
  [PAGE_LAYOUT_TYPE.CARD]?: boolean;
  [PAGE_LAYOUT_TYPE.GALLERY]?: boolean;
  [PAGE_LAYOUT_TYPE.MASONRY]?: boolean;
  [PAGE_LAYOUT_TYPE.YEARLY]?: boolean;
  [PAGE_LAYOUT_TYPE.MONTH_GROUP]?: boolean;
  [PAGE_LAYOUT_TYPE.VERTICAL]?: boolean;
  [PAGE_LAYOUT_TYPE.HORIZONTAL]?: boolean;
  [PAGE_LAYOUT_TYPE.MINI]?: boolean;
  [PAGE_LAYOUT_TYPE.EXTEND]?: boolean;
  [PAGE_LAYOUT_TYPE.ROLLPLAY]?: boolean;
  [PAGE_LAYOUT_TYPE.CAMP]?: boolean;
  [PAGE_LAYOUT_TYPE.DEFAULT]?: boolean;
  [PAGE_LAYOUT_TYPE.DIARY]?: boolean;
  [PAGE_LAYOUT_TYPE.WEEKLY]?: boolean;
  [PAGE_LAYOUT_TYPE.STORY]?: boolean;
  [PAGE_LAYOUT_TYPE.MONTHLY]?: boolean;
  [PAGE_LAYOUT_TYPE.PORTFOLIO]?: boolean;
}
